export const TENANTS = "tenants";

export const TENANT_INFO = "tenant-info";
export const AGENT_GROUPS = "agent-groups";
export const AGENTS = "users";
export const PROFILE = "profile";
export const QUEUES = "queues";

export const SMS_CHANNELS = "sms-channels";

export const EMAIL_CHANNELS = "email-channels";
export const PHONE_CHANNELS = "phone-channels";
